import { css } from '@emotion/react';
import rem from './rem';
const shadowSize = 4;
const shadowRadius = 4;
const shadowColor = 'rgba(0,0,0, 0.08)';
/** Shadow to display on bottom of element. */
const bottomShadow = css `
  box-shadow: 0 ${rem(shadowSize)} ${rem(shadowRadius)} 0 ${shadowColor};
`;
/** Shadow to display on top of element. */
const topShadow = css `
  box-shadow: 0 -${rem(shadowSize)} ${rem(shadowRadius)} 0 ${shadowColor};
`;
export { bottomShadow, topShadow, };
